import { bootTool } from '../../core/boot';
import { mountPii } from './ui';

bootTool('[data-kb-tool="pii-detector"]', mountPii);
